<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="项目名称" prop="projectId">
              <el-select disabled v-model="form.projectId" style="width:100%" placeholder="请选择">
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="物料名称" prop="consumableId">
              <el-select
                v-model="form.consumableId"
                style="width:100%"
                disabled
               
              >
                <el-option
                  v-for="item in matetialList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物料编码" prop="consumableCode">
              <el-input v-model="form.consumableCode" maxlength="100" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库名称" prop="warehouseName">
              <el-input v-model="form.warehouseName" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="库存上限"
              prop="upWarnValue"
              :rules="{ validator: validate2(form.downWarnValue), trigger: 'blur' }"
            >
              <el-input v-model="form.upWarnValue" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="库存下限"
              prop="downWarnValue"
              :rules="{ validator: validate(form.upWarnValue), trigger: 'blur' }"
            >
              <el-input v-model="form.downWarnValue" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { getMatetial, getTotalWarehouseWarnSetting, stockWarnUpdate } from './index';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    projectId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],

      form: {
        projectId: '',
        downWarnValue: '',
        upWarnValue: '',
      },
      formRules: {
        consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        projectId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    validate(val) {
     
     return (rule, value, callback) => {
       var reg=/^[0-9]{0,8}?$/;
       if(this.vdui.isNotEmpty(value)){
        let flag= reg.test(value)
        if(!flag){
         callback(new Error('请输入0-99,999,999的整数'));
        }
       }
       if (this.vdui.isNotEmpty(val) && this.vdui.isNotEmpty(value)) {
         if (Number(value) > Number(val)) {
           callback(new Error('下限不能大于上限'));
         } else {
           callback();
         }
       } else {
         callback();
       }
     };
   },
   validate2(val) {
     return (rule, value, callback) => {
       var reg=/^[0-9]{0,8}?$/;
       if(this.vdui.isNotEmpty(value)){
        let flag= reg.test(value)
        if(!flag){
         callback(new Error('请输入0-99,999,999的整数'));
        }
       }
       console.log(val, value);
       if (this.vdui.isNotEmpty(val) && this.vdui.isNotEmpty(value)) {
         if (Number(value) < Number(val)) {
           callback(new Error('上限不能小于下限'));
         } else {
           callback();
         }
       } else {
         callback();
       }
     };
   },
    
    async initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      this.form.projectId = this.row.projectId;
      this.form.warehouseName =this.row.warehouseName
      this.form.type = this.row.type
      this.form .consumableCode = this.row.consumableCode
      this.form .consumableId = this.row.consumableId
      this.form .id = this.row.id
      this.form.downWarnValue = this.row.downWarnValue
      this.form.upWarnValue = this.row.upWarnValue
      if(this.form.type==1){
        this.form.warehouseName='总仓库'
      }
        await getMatetial({ projectId: this.form.projectId }).then((res) => {
          this.matetialList = res.data;

        
        });
    },
    saveRecord() {
      if ((this.model = 'add')) {
       
        stockWarnUpdate(this.form).then((res) => {
          this.$message.success('配置成功');
          this.$emit('success');
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
</style>
